export const videoLinkSingle = (
  videoId: string,
  isEditMode: boolean = false
): string => {
  let link = `/video/${videoId}`;
  if (isEditMode) {
    link += "?mode=edit";
  }
  return link;
};
